<div class="confirm-container">
  <span mat-dialog-title>Add Supportive Services Included Type</span>
  <div mat-dialog-content>
    <div><b>Current List of Types</b></div>

    <ul>
      @for (type of attributes; track type) {
        <li>
          {{type.name}}
        </li>
      }
    </ul>

    <div>
      <mat-form-field appearance="fill">
        <mat-label>New Supportive Services Included Type</mat-label>
        <input matInput [(ngModel)]="newSupportiveServicesIncluded">
      </mat-form-field>
    </div>

    @if (checkName()) {
      <div>
        <small class="text-warning">Enter a unique Supportive Services Included Type.</small>
      </div>
    }

    <div mat-dialog-actions style="float:right;margin:20px;">
      <button mat-button [mat-dialog-close]="{ clicked: 'Ok', name: newSupportiveServicesIncluded }" [disabled]="checkName()">Ok</button>
      <button mat-button (click)="onNoClick()">
        Cancel
      </button>
    </div>
  </div>
</div>
